import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import NumbersOutlinedIcon from "@mui/icons-material/NumbersOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import SolarPowerOutlinedIcon from "@mui/icons-material/SolarPowerOutlined";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import { memo } from "react";
import PropTypes from "prop-types";

import { toJalaliFullDate } from "../../../../../middleware/middleware";
import { CRM_CARD_SX } from "./initialReviewStyles";

const MetaItem = ({ icon: Icon, label, value }) => {
  if (!value && value !== 0) return null;
  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
      {Icon ? <Icon sx={{ fontSize: 18, color: "primary.main", flexShrink: 0 }} /> : null}
      <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0, lineHeight: 1.6 }}>
        {label}:
      </Typography>
      <Typography variant="body2" fontWeight={600} sx={{ lineHeight: 1.6 }} title={String(value)}>
        {value}
      </Typography>
    </Stack>
  );
};

MetaItem.propTypes = {
  icon: PropTypes.elementType,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const RequestSummaryCard = memo(({ values = {}, workflowStageTitle = "" }) => {
  const fullName =
    [values.firstName, values.lastName].filter(Boolean).join(" ") ||
    values.fullName ||
    "—";
  const requestNo = values.referenceID ?? values.referenceId ?? values.id;

  return (
    <Paper elevation={0} sx={{ ...CRM_CARD_SX, p: { xs: 2, md: 2.5 } }}>
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", md: "center" }}
      >
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ mb: 1 }}>
            <Typography variant="h6" fontWeight={800} sx={{ lineHeight: 1.4 }}>
              {requestNo ? `پرونده #${requestNo}` : "پرونده"}
              {fullName !== "—" ? ` — ${fullName}` : ""}
            </Typography>
            {workflowStageTitle ? (
              <Chip
                size="small"
                color="primary"
                label={workflowStageTitle}
                sx={{ fontWeight: 600 }}
              />
            ) : null}
          </Stack>
          <Stack
            direction="row"
            flexWrap="wrap"
            useFlexGap
            sx={{ gap: 2, rowGap: 1 }}
          >
            <MetaItem
              icon={CalendarTodayOutlinedIcon}
              label="تاریخ ثبت"
              value={toJalaliFullDate(values.createOn) || undefined}
            />
            <MetaItem
              icon={NumbersOutlinedIcon}
              label="وضعیت"
              value={values.requestConfirmTitle}
            />
            <MetaItem icon={LocationCityOutlinedIcon} label="شهر" value={values.cityName} />
            <MetaItem
              icon={SolarPowerOutlinedIcon}
              label="ظرفیت"
              value={values.plantCapacityTitle || values.plantCapacity}
            />
            <MetaItem
              label="نیاز به وام"
              value={values.needsLoan ? "بله" : "خیر"}
            />
            <MetaItem icon={PhoneOutlinedIcon} label="موبایل" value={values.mobile} />
            <MetaItem
              icon={LocationCityOutlinedIcon}
              label="استان"
              value={values.provinceName}
            />
            <MetaItem icon={PersonOutlineIcon} label="نوع شخص" value={values.agreementKindTitle} />
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
});

RequestSummaryCard.displayName = "RequestSummaryCard";

RequestSummaryCard.propTypes = {
  values: PropTypes.object,
  workflowStageTitle: PropTypes.string,
};

export default RequestSummaryCard;
